var map = {
	"./assets/fonts/Glyphter.svg": "2b23",
	"./assets/fonts/Glyphter/font/Glyphter.svg": "da09",
	"./assets/fonts/boxicons.svg": "e1e2",
	"./assets/fonts/dripicons-v2.svg": "38b8",
	"./assets/fonts/fa-brands-400.svg": "ecf4",
	"./assets/fonts/fa-regular-400.svg": "347e",
	"./assets/fonts/fa-solid-900.svg": "f074",
	"./assets/fonts/global-fonts/boxicons.svg": "5e50",
	"./assets/images/Debt.svg": "e582",
	"./assets/images/Mpos.svg": "73d9",
	"./assets/images/N360.svg": "1a19",
	"./assets/images/Payment_Cash.svg": "9157",
	"./assets/images/Payment_Mpos.svg": "21cf",
	"./assets/images/Payment_Transfer.svg": "ca8a",
	"./assets/images/acceptOrder.svg": "ab7b",
	"./assets/images/add-box.svg": "d55c",
	"./assets/images/add-inventory.svg": "e0e1",
	"./assets/images/add-staff.svg": "c39a",
	"./assets/images/angle-down.svg": "0954",
	"./assets/images/app-store.svg": "36ea",
	"./assets/images/arrow-down-square.svg": "6d3f",
	"./assets/images/arrow-right-primary.svg": "02f3",
	"./assets/images/barcode-overwrite.svg": "8d5c",
	"./assets/images/barcode.svg": "c72c",
	"./assets/images/bg-chill-guy.svg": "1db5",
	"./assets/images/bg-gradient.svg": "39a0",
	"./assets/images/bg-round-fff.svg": "8c6d",
	"./assets/images/bg-wave.svg": "de3f",
	"./assets/images/bg-working-guy.svg": "6b03",
	"./assets/images/book-question.svg": "f950",
	"./assets/images/box-decline.svg": "5d1d",
	"./assets/images/box-nothing.svg": "28ce",
	"./assets/images/box_barcode.svg": "fe4a",
	"./assets/images/boxes.svg": "c24a",
	"./assets/images/cashier-machine.svg": "41d3",
	"./assets/images/co-worker.svg": "a601",
	"./assets/images/cod.svg": "e92b",
	"./assets/images/credit.svg": "d068",
	"./assets/images/customer-nope-1.svg": "5fcb",
	"./assets/images/customer-nope.svg": "ff2d",
	"./assets/images/db-banner-img.svg": "bf2c",
	"./assets/images/db-doanh-thu.svg": "d7f1",
	"./assets/images/db-don-bi-huy.svg": "6831",
	"./assets/images/db-don-hoan-thanh.svg": "a73b",
	"./assets/images/db-khach-hang.svg": "0d1c",
	"./assets/images/db-khoan-no-thu.svg": "f05d",
	"./assets/images/db-khoan-no-tra.svg": "c58b",
	"./assets/images/delete-circle.svg": "b846",
	"./assets/images/exclamation-triangle.svg": "f532",
	"./assets/images/filter.svg": "b05f",
	"./assets/images/frame.svg": "327e",
	"./assets/images/global-img/banner-ads.svg": "cac1",
	"./assets/images/global-img/emvco.svg": "e4bb",
	"./assets/images/global-img/giaithuong.svg": "7042",
	"./assets/images/global-img/icon-head/1.svg": "901e",
	"./assets/images/global-img/icon-head/2.svg": "1a33",
	"./assets/images/global-img/icon-head/3.svg": "4280",
	"./assets/images/global-img/icon-head/4.svg": "1b9f",
	"./assets/images/global-img/icon-head/5.svg": "f86d",
	"./assets/images/global-img/icon-head/6.svg": "433f",
	"./assets/images/global-img/icon-head/7.svg": "7427",
	"./assets/images/global-img/img-sm/atm360-sm.svg": "5780",
	"./assets/images/global-img/img-sm/defaul.svg": "569d",
	"./assets/images/global-img/img-sm/favicon-loyalty.svg": "bf72",
	"./assets/images/global-img/img-sm/gpdieukhoan.svg": "29cd",
	"./assets/images/global-img/img-sm/gpguide.svg": "ffbd",
	"./assets/images/global-img/img-sm/gpqrcode.svg": "6afc",
	"./assets/images/global-img/img-sm/gpquesion.svg": "8b0d",
	"./assets/images/global-img/img-sm/gptaichinh.svg": "805c",
	"./assets/images/global-img/img-sm/gpthanhtoan.svg": "14e2",
	"./assets/images/global-img/img-sm/gptragop.svg": "fe23",
	"./assets/images/global-img/img-sm/invoice-sm.svg": "6f9b",
	"./assets/images/global-img/img-sm/link-payon-sm.svg": "079d",
	"./assets/images/global-img/img-sm/maketplace-sm.svg": "a954",
	"./assets/images/global-img/img-sm/mc360-sm.svg": "162a",
	"./assets/images/global-img/img-sm/megadoc-sm.svg": "e5ad",
	"./assets/images/global-img/img-sm/mpos-sm.svg": "0814",
	"./assets/images/global-img/img-sm/mysalon-sm.svg": "6b4c",
	"./assets/images/global-img/img-sm/myspa-sm.svg": "3e76",
	"./assets/images/global-img/img-sm/nextaca-sm.svg": "544b",
	"./assets/images/global-img/img-sm/nextacc-sm.svg": "276c",
	"./assets/images/global-img/img-sm/nextbuy-sm.svg": "28e4",
	"./assets/images/global-img/img-sm/nextcam-sm.svg": "e969",
	"./assets/images/global-img/img-sm/nexthr-sm.svg": "8dea",
	"./assets/images/global-img/img-sm/nextinvoice-sm.svg": "256c",
	"./assets/images/global-img/img-sm/nextlend-sm.svg": "7bf9",
	"./assets/images/global-img/img-sm/nextorder-sm.svg": "1246",
	"./assets/images/global-img/img-sm/nextphar-sm.svg": "c0c7",
	"./assets/images/global-img/img-sm/nextshop-sm.svg": "4be1",
	"./assets/images/global-img/img-sm/omisell-sm.svg": "10c2",
	"./assets/images/global-img/img-sm/payon-sm.svg": "658d",
	"./assets/images/global-img/img-sm/posapp-sm.svg": "4c0f",
	"./assets/images/global-img/img-sm/vimo-mc-sm.svg": "b5c9",
	"./assets/images/global-img/img-sm/vimo-sm.svg": "d240",
	"./assets/images/global-img/logo-nextpay-color.svg": "c1e6",
	"./assets/images/global-img/logo-nextpay.svg": "bc6f",
	"./assets/images/global-img/master.svg": "69a6",
	"./assets/images/global-img/nhnhanuoc.svg": "9917",
	"./assets/images/global-img/pcj.svg": "5bf2",
	"./assets/images/global-img/red100.svg": "1436",
	"./assets/images/global-img/visa.svg": "8edf",
	"./assets/images/graph-blank.svg": "f2da",
	"./assets/images/i-store.svg": "e330",
	"./assets/images/i-zoom.svg": "cf5c",
	"./assets/images/ic-home.svg": "925e",
	"./assets/images/ico/file-export.svg": "6f0b",
	"./assets/images/ico/file-import.svg": "6016",
	"./assets/images/icon-back.svg": "e2fa",
	"./assets/images/icon-box.svg": "15b2",
	"./assets/images/icon-contact.svg": "78b4",
	"./assets/images/icon-dilivery/box.svg": "b8ca",
	"./assets/images/icon-dilivery/bx-current-location-1.svg": "1b1f",
	"./assets/images/icon-dilivery/ghtk.svg": "5b0f",
	"./assets/images/icon-dilivery/grab.svg": "d02e",
	"./assets/images/icon-dilivery/heyu.svg": "0c82",
	"./assets/images/icon-dilivery/ic-pin-drop-1.svg": "6351",
	"./assets/images/icon-dilivery/icon-sync-alt.svg": "e95e",
	"./assets/images/icon-dilivery/icon-wrap-0.svg": "99f2",
	"./assets/images/icon-dilivery/icon-wrap-1.svg": "490d",
	"./assets/images/icon-dilivery/money-bill.svg": "624b",
	"./assets/images/icon-discard-file.svg": "ed20",
	"./assets/images/icon-home.svg": "2a74",
	"./assets/images/icon-modal-danger.svg": "558c",
	"./assets/images/icon-modal-warning.svg": "f366",
	"./assets/images/icon-pos-success.svg": "6aba",
	"./assets/images/icon-quest.svg": "d77f",
	"./assets/images/icon-search-box.svg": "4032",
	"./assets/images/icon-wifi.svg": "596f",
	"./assets/images/icon-zoom.svg": "d631",
	"./assets/images/icon/menu_option.svg": "d6f8",
	"./assets/images/icon/step_import.svg": "b675",
	"./assets/images/icon/step_import_convert.svg": "0ef0",
	"./assets/images/icon/step_import_fail.svg": "0eed",
	"./assets/images/icon/step_import_success.svg": "44d8",
	"./assets/images/iconInventory.svg": "6df7",
	"./assets/images/iconMposCheck.svg": "a307",
	"./assets/images/info-circle.svg": "dfe56",
	"./assets/images/landing-img/baby.svg": "6779",
	"./assets/images/landing-img/bar.svg": "45fa",
	"./assets/images/landing-img/cosmetic.svg": "e30a",
	"./assets/images/landing-img/fashion.svg": "eea5",
	"./assets/images/landing-img/food.svg": "c4c4",
	"./assets/images/landing-img/furniture.svg": "81fd",
	"./assets/images/landing-img/gift.svg": "2f40",
	"./assets/images/landing-img/insurance.svg": "5004",
	"./assets/images/landing-img/intro-1.svg": "4749",
	"./assets/images/landing-img/intro-2.svg": "44ef1",
	"./assets/images/landing-img/intro-3.svg": "da61",
	"./assets/images/landing-img/logo-nextshop.svg": "544c",
	"./assets/images/landing-img/machine.svg": "866a",
	"./assets/images/landing-img/pharmacy.svg": "dee6",
	"./assets/images/landing-img/phone.svg": "b505",
	"./assets/images/landing-img/salon.svg": "b5e3",
	"./assets/images/landing-img/service.svg": "9bf3",
	"./assets/images/landing-img/stationary.svg": "f6b9",
	"./assets/images/landing-img/store.svg": "4872",
	"./assets/images/landing-img/vehicle.svg": "a944",
	"./assets/images/landing-new/QRCode-nextshop.svg": "e1bf6",
	"./assets/images/landing-new/app-store.svg": "95df",
	"./assets/images/landing-new/baby.svg": "9bb4",
	"./assets/images/landing-new/barcode-scanner.svg": "9e26",
	"./assets/images/landing-new/bg-sphere.svg": "3d16",
	"./assets/images/landing-new/bill-printer.svg": "4389",
	"./assets/images/landing-new/camera-ai.svg": "3ca8",
	"./assets/images/landing-new/car.svg": "ef7f",
	"./assets/images/landing-new/chevron-down.svg": "5f09",
	"./assets/images/landing-new/chevron-up.svg": "4fbb",
	"./assets/images/landing-new/cog-double.svg": "a099",
	"./assets/images/landing-new/cosmetic.svg": "fc38",
	"./assets/images/landing-new/ecommerce.svg": "5bcb",
	"./assets/images/landing-new/electrical-appliance.svg": "8e2e",
	"./assets/images/landing-new/emvco.svg": "a632",
	"./assets/images/landing-new/f&b.svg": "e377",
	"./assets/images/landing-new/food.svg": "6248",
	"./assets/images/landing-new/giaithuong.svg": "a81a",
	"./assets/images/landing-new/gift.svg": "7eaa",
	"./assets/images/landing-new/ice-tea.svg": "f8bc",
	"./assets/images/landing-new/icon-minus.svg": "b13e",
	"./assets/images/landing-new/icon-plus.svg": "f937",
	"./assets/images/landing-new/insurance.svg": "e296",
	"./assets/images/landing-new/interior.svg": "3f68",
	"./assets/images/landing-new/landing-main-img.svg": "de45",
	"./assets/images/landing-new/laptop-1.svg": "49c8",
	"./assets/images/landing-new/logo-nextpay-color.svg": "8e35",
	"./assets/images/landing-new/main-icon-1.svg": "aec7",
	"./assets/images/landing-new/main-icon-2.svg": "bea1",
	"./assets/images/landing-new/main-icon-3.svg": "1af3",
	"./assets/images/landing-new/master.svg": "2892",
	"./assets/images/landing-new/messages-bubble.svg": "cc7d",
	"./assets/images/landing-new/mpos-devices.svg": "1194",
	"./assets/images/landing-new/mpos-md.svg": "8939",
	"./assets/images/landing-new/mpos-sm.svg": "0d82",
	"./assets/images/landing-new/n360.svg": "a6308",
	"./assets/images/landing-new/next360-rounded-sm.svg": "2330",
	"./assets/images/landing-new/next360-rounded.svg": "c5b0",
	"./assets/images/landing-new/next360_logo.svg": "5b48",
	"./assets/images/landing-new/nextcam-sm.svg": "a3ae",
	"./assets/images/landing-new/nextlend-sm.svg": "bf3d",
	"./assets/images/landing-new/nextshop-app.svg": "90f2",
	"./assets/images/landing-new/nhnhanuoc.svg": "2882",
	"./assets/images/landing-new/payon-sm.svg": "4a6f",
	"./assets/images/landing-new/pcj.svg": "73c3",
	"./assets/images/landing-new/pharmacy.svg": "2d58",
	"./assets/images/landing-new/play-store.svg": "6a63",
	"./assets/images/landing-new/red100.svg": "b347",
	"./assets/images/landing-new/service.svg": "f0d2",
	"./assets/images/landing-new/shopping-bag.svg": "e073",
	"./assets/images/landing-new/spa.svg": "602c",
	"./assets/images/landing-new/stationary.svg": "315b",
	"./assets/images/landing-new/tick_grey.svg": "3f74",
	"./assets/images/landing-new/tick_white.svg": "8079",
	"./assets/images/landing-new/visa.svg": "2fdf",
	"./assets/images/location-icon.svg": "ea95",
	"./assets/images/logo-bl.svg": "9f14",
	"./assets/images/logo-m.svg": "1b0d",
	"./assets/images/logo-mpos.svg": "1274",
	"./assets/images/logo-ns.svg": "0314",
	"./assets/images/mp-1.svg": "ec76",
	"./assets/images/mp-2.svg": "7484",
	"./assets/images/mp-3.svg": "4532",
	"./assets/images/mpos-integrate.svg": "c813",
	"./assets/images/nextshop-logo.svg": "b975",
	"./assets/images/no-customer-supplier.svg": "6680",
	"./assets/images/pencil.svg": "68e3",
	"./assets/images/person-quest.svg": "6acc",
	"./assets/images/play-store.svg": "970f",
	"./assets/images/remove.svg": "f08b",
	"./assets/images/remove1.svg": "cc6f",
	"./assets/images/search.svg": "22ee",
	"./assets/images/shipping-fast.svg": "3913",
	"./assets/images/shipping.svg": "e844",
	"./assets/images/shopping-cart.svg": "639e",
	"./assets/images/steps.svg": "c369",
	"./assets/images/store-bg.svg": "c8a3",
	"./assets/images/store.svg": "dd3a",
	"./assets/images/user.svg": "c9d8",
	"./assets/images/vector-down.svg": "55d5",
	"./assets/menu-icons/fa-address-card.svg": "00ab",
	"./assets/menu-icons/fa-box.svg": "be3b",
	"./assets/menu-icons/fa-cash-register.svg": "e7d2",
	"./assets/menu-icons/fa-chart-line.svg": "417c",
	"./assets/menu-icons/fa-clipboard-list.svg": "8199",
	"./assets/menu-icons/fa-clipboard-user.svg": "5e08",
	"./assets/menu-icons/fa-gear.svg": "6a61",
	"./assets/menu-icons/fa-house.svg": "d5e6",
	"./assets/menu-icons/fa-money-check-dollar.svg": "2d46",
	"./assets/menu-icons/fa-store.svg": "13ef",
	"./assets/menu-icons/fa-tags.svg": "0901",
	"./assets/menu-icons/fa-truck.svg": "9ecb",
	"./assets/menu-icons/fa-users-rectangle.svg": "c4d0",
	"./assets/menu-icons/fa-warehouse.svg": "9ef0",
	"./assets/order-icon/arrow-detail.svg": "c4fb",
	"./assets/order-icon/arrow-down.svg": "127c",
	"./assets/order-icon/delivery-truck.svg": "5445",
	"./assets/order-icon/money-card.svg": "d4a5",
	"./assets/order-icon/more-info.svg": "8404",
	"./assets/shipper-icons/external-link-alt.svg": "26bc",
	"./components/icons/icon_no_file.svg": "173f",
	"./components/icons/icon_reject.svg": "c298"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fa53";